<template>
  <div class="lds-ring">
    <div v-for="n in 4" :key="n" :style="borderColor" />
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#2E50D4',
    },
  },
  computed: {
    borderColor() {
      return `border-color: ${this.color} transparent transparent transparent;`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
